import { Injectable, signal } from '@angular/core';
import { imagePlaceholderUrl } from 'sham-components/shared';

@Injectable({
  providedIn: 'root',
})
export class ShamSiteIdentity {
  public readonly storeUrl = signal('#_');
  public readonly sellerSignUpUrl = signal('#_');
  public readonly driverSignUpUrl = signal('#_');

  public readonly websiteName = signal('SHAMSTORE');
  public readonly websiteSlogan = signal('Enjoy to Buy');

  public readonly favicon = signal(imagePlaceholderUrl(400));
  public readonly squareLogo = signal(imagePlaceholderUrl(400));
  public readonly logoImage = signal(imagePlaceholderUrl(720, 480));
}
